var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'is-logged-in': _vm.account.status.loggedIn },attrs:{"id":"app"}},[_c('app-header'),(_vm.account.status.loggedIn)?_c('app-nav'):_vm._e(),_c('main',{staticClass:"o-main"},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1),_c('alert')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }